import { Middleware } from '@reduxjs/toolkit';

import {
    _pushHistory,
    setSelectedDate,
    setSelectedEntities,
    setSelectedOrderId,
    setViewMode,
} from './calendarSlice';

export const calendarHistoryMiddleware: Middleware = (store) => (next) => (action) => {
    const relevantActions = [
        setSelectedEntities.type,
        setSelectedOrderId.type,
        setSelectedDate.type,
        setViewMode.type,
    ];

    const result = next(action);

    if (relevantActions.includes(action.type)) {
        store.dispatch(_pushHistory());
    }

    return result;
};
